import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d1199fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header d-flex justify-content-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title m-0 pt-1 pt-md-0" }, " Download Documents ", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "modal_content mt-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h3 mb-4" }, " Course Content: ", -1))
const _hoisted_6 = { class: "rounded-2 blue-border" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "spinner-border spinner-border-sm ms-auto",
  role: "status"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "footer float-end m-3 mt-1 me-0 me-md-3" }

import BsDialog from '@/components/BsDialog/BsDialog.vue'
import XCircleIcon from '@/icons/XCircleIcon.vue'
import DownloadIcon from '@/icons/DownloadIcon.vue'
import BarButton from '@/components/BarButton'


import { defineComponent, defineProps, defineEmits } from 'vue'
const __default__ = defineComponent({
  name: 'DocumentDownloadModal'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    fileNames: {},
    documentsDownloading: {}
  },
  emits: ["download-files"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
    
function downloadFiles(files: string[]) {
  emit('download-files', files)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BsDialog, {
    "class-names": "document-download-modal",
    "close-on-escape": "",
    "close-on-backdrop-click": ""
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "button white-focus-outline",
          onClick: close
        }, [
          _createVNode(XCircleIcon)
        ], 8, _hoisted_3)
      ])
    ]),
    footer: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_unref(BarButton), {
          mode: "outline",
          class: "footer-button",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(" <  Go back ")
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_unref(BarButton), {
          mode: "outline",
          class: "footer-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadFiles(props.fileNames)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Download all ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fileNames, (fileName) => {
            return (_openBlock(), _createElementBlock("div", {
              key: fileName,
              class: "document-row p-3 py-2"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn btn-link link-blue",
                  onClick: ($event: any) => (downloadFiles([fileName]))
                }, _toDisplayString(fileName), 9, _hoisted_8),
                _withDirectives(_createElementVNode("button", {
                  class: "btn ms-auto black-focus-outline",
                  onClick: ($event: any) => (downloadFiles([fileName]))
                }, [
                  _createVNode(DownloadIcon)
                ], 8, _hoisted_9), [
                  [_vShow, !props.documentsDownloading.includes(fileName)]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_10, _hoisted_12, 512), [
                  [_vShow, props.documentsDownloading.includes(fileName)]
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})